import { EmbarcacaoDetailLoadGateProvider } from "../../hooks/embarcacao-detail-load-gate.context";
import { EmbarcacaoFichaProvider } from "../../hooks/embarcacao-ficha.context";
import { useEmbarcacaoDetalheExportacao } from "../../hooks/use-embarcacao-detalhe-exportacao";
import type { EmbarcacaoDetailDialogProps } from "./types-embarcacao-detail-dialog";
import { useEmbarcacaoDetailDialog } from "./use-embarcacao-detail-dialog";
import { EmbarcacaoDetailDialogView } from "./view-embarcacao-detail-dialog";

/**
 * Os provedores ficam acima do ViewModel: o botão Exportar (que lê a fila de carga) e as seções (que a alimentam e
 * leem a ficha da embarcação) são filhos da View.
 */
export function EmbarcacaoDetailDialog(props: EmbarcacaoDetailDialogProps) {
  const vm = useEmbarcacaoDetailDialog(props);
  const exportacao = useEmbarcacaoDetalheExportacao(props);

  return (
    <EmbarcacaoDetailLoadGateProvider>
      <EmbarcacaoFichaProvider embarcacaoId={props.embarcacaoId}>
        <EmbarcacaoDetailDialogView {...vm} exportacao={exportacao} />
      </EmbarcacaoFichaProvider>
    </EmbarcacaoDetailLoadGateProvider>
  );
}

export type * from "./types-embarcacao-detail-dialog";
